import { blue, green, neutral, orange, purpleBrand, red } from './primitives.colors';

/** Semântica ARIDE — tema claro (valores resolvidos). */
export const semanticLight = {
  brandMain: purpleBrand[600],
  brandSupport: purpleBrand[600],
  primaryMain: purpleBrand[700],
  primaryLight: purpleBrand[600],
  primaryDark: purpleBrand[800],
  primaryContrastText: neutral[0],
  secondaryMain: neutral[300],
  secondaryLight: neutral[200],
  secondaryDark: neutral[400],
  secondaryContrastText: neutral[1100],
  tertiaryMain: purpleBrand[800],
  tertiaryContrastText: neutral[1100],
  textPrimary: neutral[1100],
  textSecondary: neutral[1100],
  textDisabled: neutral[400],
  textPlaceholder: neutral[500],
  accent: neutral[200],
  backgroundPrimary: neutral[0],
  backgroundSecondary: neutral[100],
  backgroundTertiary: purpleBrand[100],
  backgroundMute: neutral[200],
  backgroundBlack: neutral[1100],
  divider: neutral[500],
  elevation: neutral[400],
  successMain: green[600],
  successLight: green[500],
  successDark: green[700],
  successContrastText: neutral[1100],
  errorMain: red[800],
  errorLight: red[400],
  errorDark: red[900],
  errorContrastText: neutral[0],
  warningMain: orange[400],
  warningLight: orange[200],
  warningDark: orange[600],
  warningContrastText: neutral[1100],
  infoMain: blue[400],
  infoLight: blue[200],
  infoDark: blue[600],
  infoContrastText: neutral[1100],
  chart1: purpleBrand[600],
  chart2: blue[600],
  chart3: green[600],
  chart4: orange[600],
  chart5: red[600]
} as const;
